import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Await, useNavigate } from "react-router-dom";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { GetServiceCaller, PostServiceCaller } from "../../../../services/serviceCaller";
import { API_URL } from "../../../../constants";
import Select from "react-select"
import { Table } from "react-bootstrap";
import { toast } from "react-toastify";
import { FaSpinner } from "react-icons/fa";
import * as Yup from "yup";

const IncomeTaxSlabAdd = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(updateNavbarHeading("Add Income Tax Slab"));
    fetchGetData();

  }, []);


  const initialFormDataData = {
    FYFromDate: "",
    FYToDate: "",
    FYYear: "",
    TaxRebateLimit: "",
    TaxRebateExcemtion: "",
    TaxEducationCESS: "",
    TaxRegime: "",
    TaxSurcharge: "",
    incometaxslab: [

      {
        LineNo: 1,
        Gender_020: null,
        FromAmount: 0,
        ToAmount: 0,
        TaxPercent: 0
      }

    ],
    incometaxexception: [
      {
        LineNo: "",
        ITSectionID: "",
        ITDeductionType_165: "",
        MaxAmount: "",
        TaxPercent: ""
      }
    ]
  };

  const [submitted, setSubmitted] = useState(false)
  const [deductionTypeOpt, setDeductionTypeOpt] = useState([]);
  const [fyYearOptions, setFYYearOptions] = useState([]);
  const [genderOptions, setGenderOptions] = useState([]);
  const [regimeOptions, setRegimeOptions] = useState([]);
  const [formData, setFormData] = useState(initialFormDataData);
  console.log("formData", formData);

  const fetchGetData = async () => {
    try {
      let response;
      response = await GetServiceCaller(`${API_URL}income-slab-getdata`);

      if (response?.status === 200) {
        const cleanedData = response?.data;
        const YearOpt = cleanedData?.financialyear?.map(el => ({
          value: el.value,
          label: el?.text,
          fyFromDate: el?.FYFromDate,
          fyToDate: el?.FYToDate
        }))
        const genderOpt = cleanedData?.gender?.map(el => ({
          value: el.value,
          label: el?.text
        }))
        const regimeOpt = cleanedData?.regime?.map(el => ({
          value: el.value,
          label: el?.text
        }))
        const deductionOpt = cleanedData?.deductiontype?.map(el => ({
          value: el.value,
          label: el?.text
        }))
        setDeductionTypeOpt(deductionOpt || [])
        setFYYearOptions(YearOpt.reverse() || [])
        setGenderOptions(genderOpt || [])
        setRegimeOptions(regimeOpt || [])
      }
    } catch (error) {
      console.log("Fetching Error ", error);
    }
  };




  const fectchTaxExpData = async () => {
    try {
      let respone;

      respone = await GetServiceCaller(`${API_URL}income-slab-getTaxExemptData?p_fromDate=${formData?.FYFromDate}&p_toDate=${formData?.FYToDate}`)

      if (respone?.status == 200) {
        const cleanedData = respone?.data?.taxsection;
        console.log("cleanedData::", cleanedData);
        setFormData(prevData => ({
          ...prevData, incometaxexception: cleanedData
        }))
      }
    } catch (error) {
      console.error("Fetching TaxExp APi error", error);

    }
  }

  useEffect(() => {
    if (formData?.TaxRegime) {

      fectchTaxExpData()
    }
  }, [formData?.TaxRegime])
  const handleAddLineDetail = () => {
    const currentRow =
      formData.incometaxslab.length !== 0
        ? formData.incometaxslab[formData.incometaxslab.length - 1]
        : null;

    if (currentRow && currentRow.Gender_020 === null) {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    // Find the smallest missing line number
    let newLineNo = 1;
    const existingLineNos = formData.incometaxslab.map((row) =>
      parseInt(row.LineNo)
    );

    while (existingLineNos.includes(newLineNo)) {
      newLineNo++;
    }

    setFormData((prevState) => ({
      ...prevState,
      incometaxslab: [
        ...prevState.incometaxslab,

        {
          LineNo: newLineNo.toString(),
          Gender_020: null,
          FromAmount: 0,
          ToAmount: 0,
          TaxPercent: 0
        }
      ],
    }));
  };



  const [errors, setErrors] = useState({});

  console.log("errors", errors);

  // Assume formData is declared like:
  // const [formData, setFormData] = useState({ FYFromDate: "", FYToDate: "", TaxRegime: "", incometaxslab: [], ... });

  const schema = Yup.object().shape({
    FYYear: Yup.string().required("Year is required"),
    TaxRegime: Yup.string().required("Tax Regime is required"),
    incometaxslab: Yup.array()
      .of(
        Yup.object().shape({
          Gender_020: Yup.number().typeError("Gender is required").required("Gender is required"),
          FromAmount: Yup.string().nullable(),
          ToAmount: Yup.string().nullable(),
          TaxPercent: Yup.string().nullable()
        })
      )
      .min(1, "At least one income tax slab is required"),
  });

  // ✅ Validate individual field
  const validateField = async (fieldName, updatedData) => {
    try {
      await schema.validateAt(fieldName, updatedData);
      setErrors(prev => ({ ...prev, [fieldName]: "" }));
    } catch (err) {
      if (err.path === fieldName) {
        setErrors(prev => ({ ...prev, [fieldName]: err.message }));

        // Display toast if needed
        if (fieldName === "incometaxslab" || fieldName.startsWith("incometaxslab[")) {
          toast.error(err.message, { position: "top-right" });
        }
      } else {
        console.error("Unexpected validation error:", err);
      }
    }
  };

  // ✅ Handle select inputs
  const handleSelectChange = (value, name) => {
    if (name === "TaxRegime") {
      if (!formData?.FYFromDate || !formData?.FYToDate) {
        toast.error("Select Financial Year First");
        return;
      }
    }

    let updatedData;

    if (name === "FYYear") {
      updatedData = {
        ...formData,
        FYFromDate: value.fyFromDate,
        FYToDate: value.fyToDate,
        FYYear: value.fyFromDate,
      };
    } else {
      updatedData = {
        ...formData,
        [name]: value,
      };
    }

    setFormData(updatedData);
    validateField(name, updatedData); // ✅ Now validate with the correct updated form
  };


  // ✅ Handle text input
  const handleChange = (e) => {
    const { name, value } = e.target;

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));

    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      validateField(name, updatedData);
      return updatedData;
    });
  };



  // ✅ Handle array select field
  const handleLineSelectChange = async (value, name, index, arrayName) => {
    const updatedLines = [...formData[arrayName]];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value.value,
    };

    const updatedFormData = {
      ...formData,
      [arrayName]: updatedLines,
    };

    setFormData(updatedFormData);

    await validateField(`${arrayName}[${index}].${name}`, updatedFormData);
  };


  // ✅ Handle array input field
  const handleLineChange = async (e, index, arrayName) => {
    const { name, value } = e.target;

    const updatedLines = [...formData[arrayName]];
    updatedLines[index] = {
      ...updatedLines[index],
      [name]: value,
    };

    const updatedFormData = {
      ...formData,
      [arrayName]: updatedLines,
    };

    setFormData(updatedFormData);

    await validateField(`${arrayName}[${index}].${name}`, updatedFormData);
  };

  // ✅ Submit handler with full schema validation
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);

    try {
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // clear all errors if validation passed

      const payload = {
        FYFromDate: formData?.FYFromDate,
        FYToDate: formData?.FYToDate,
        TaxRebateLimit: formData?.TaxRebateLimit,
        TaxRebateExcemtion: formData?.TaxRebateExcemtion,
        TaxEducationCESS: formData?.TaxEducationCESS,
        TaxRegime: formData?.TaxRegime,
        TaxSurcharge: formData?.TaxSurcharge,
        incometaxexception: formData?.incometaxexception?.map(el => ({
          LineNo: el?.LineNo,
          ITSectionID: el?.ITSectionID,
          ITDeductionType_165: el?.ITDeductionType_165,
          MaxAmount: el?.MaxAmount,
          TaxPercent: el?.TaxPercent,
        })),
        incometaxslab: formData?.incometaxslab?.map(el => ({
          LineNo: el?.LineNo,
          Gender_020: el?.Gender_020,
          FromAmount: el?.FromAmount,
          ToAmount: el?.ToAmount,
          TaxPercent: el?.TaxPercent,
        })),
      };

      const response = await PostServiceCaller(`${API_URL}income-slab`, payload, "post");

      if (response?.status === 200) {

        const cleanedData = response?.data?.ID;
        navigate(`/rujul/hrm/income-tax-slab`)
        toast.success("Submitted successfully");
        setSubmitted(false);
      }
    } catch (error) {
      if (error.name === "ValidationError") {
        const formattedErrors = {};
        error.inner.forEach(err => {
          formattedErrors[err.path] = err.message;
          toast.error(err.message)
        });
        setSubmitted(false)
        setErrors(formattedErrors);
      } else {
        setSubmitted(false)
        console.error("Post API error Income Tax Slab", error);
      }
    }
  };


  const handleLineDelete = (ele, index) => {
    const updatedLines = formData?.incometaxslab?.filter(o => o.LineNo !== ele?.LineNo);
    console.log("updatedLines", updatedLines);

    setFormData(prevData => ({
      ...prevData,
      incometaxslab: updatedLines
    }));
  };


  return (
    <div className="" >

      <form
        id="formOne"
        className="rounded border border-0 bg-white  card"
        onSubmit={(e) => handleSubmit(e)}
      >

        <div className="m-3">
          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Financial Year <span className="error">*</span></label>
              <Select
                options={fyYearOptions}
                name="FYYear"
                //  value={fyYearOptions?.find(o =>
                //   o.value == formData?.FYYear
                // )}
                onChange={(selectedOptions, action) => handleSelectChange(selectedOptions, action.name)}
                placeholder="FYYear" />
              <span class="error">{errors?.FYYear}</span>

            </div>
            <div className="col-md-2">
              <label className="form-label">Tax Rebate Exemption</label>
              <input type="number" className="form-control text-end" name="TaxRebateExcemtion" placeholder="00.00" onChange={handleChange} value={formData?.TaxRebateExcemtion} />

            </div>
            <div className="col-md-2">
              <label className="form-label">Tax Rebate Limit</label>
              <input type="number" className="form-control text-end" name="TaxRebateLimit" placeholder="00.00" onChange={handleChange} value={formData?.TaxRebateLimit} />

            </div>
            <div className="col-md-2">
              <label className="form-label">Tax Education CESS</label>
              <input type="number" className="form-control text-end" name="TaxEducationCESS" placeholder="00.00" onChange={handleChange} value={formData?.TaxEducationCESS} />

            </div>
            <div className="col-md-2">
              <label className="form-label">Tax Surcharge</label>
              <input type="number" className="form-control text-end" name="TaxSurcharge" placeholder="00.00" onChange={handleChange} value={formData?.TaxSurcharge} />

            </div>
            <div className="col-md-2">
              <label className="form-label">Tax Regime<span className="error">*</span></label>
              <Select
                options={regimeOptions}
                name="TaxRegime"
                onChange={(selectedOptions, action) => handleSelectChange(selectedOptions.value, action.name)}
                value={regimeOptions?.find(o =>
                  o.value === formData?.TaxRegime
                ) || null}
                placeholder="Select Regime.." />
              <span class="error">{errors?.TaxRegime}</span>

            </div>

          </div>


          <div className="row mt-2">
            {/** Tab Code Start */}
            <ul className="nav nav-tabs overflow" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link active"
                  style={{ color: "#2F2E4B" }}
                  id="lineDetail-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#lineDetail"
                  type="button"
                  role="tab"
                  aria-controls="lineDetail"
                  aria-selected="true"
                >
                  Line Details
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className="nav-link"
                  style={{ color: "#2F2E4B" }}
                  id="taxExmpLimit-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#taxExmpLimit"
                  type="button"
                  role="tab"
                  aria-controls="taxExmpLimit"
                  aria-selected="false"
                >
                  Tax Exemption Limit
                </button>
              </li>

            </ul>
            {/** Tab Code End */}


            <div className="tab-content mt-3" id="myTabContent">
              <div
                className="tab-pane fade show active"
                id="lineDetail"
                role="tabpanel"
                aria-labelledby="lineDetail-tab"
              >
                <div className="table-responsive poc-head rounded">
                  <button
                    type="button"
                    onClick={handleAddLineDetail}
                    className="custom-btn-sm mb-2 pull-right"
                  >
                    <i class="fa fa-plus"></i>&nbsp;Add
                  </button>
                  <Table
                    style={{ background: "#ECECEC !important" }}
                    // id="poctable_head"
                    className="table table-bordered"
                  >
                    <thead id="thcolor" className="text-center align-middle  ">
                      <tr>
                        <th>
                          Gender<span className="error">*</span>
                        </th>
                        <th>
                          From Amount
                        </th>
                        <th>
                          To Amount
                        </th>
                        <th>
                          Tax Percent
                        </th>
                        <th>
                          Delete
                        </th>
                      </tr>
                    </thead>

                    <tbody>
                      {formData.incometaxslab.map((ele, index) => (
                        <tr>
                          <td>
                            <Select options={genderOptions} name="Gender_020" menu menuPlacement="bottom"
                              menuPortalTarget={document.body}
                              value={genderOptions?.find(o => o.value == ele?.Gender_020) || null}
                              onChange={(selectedOptions, action) => handleLineSelectChange(selectedOptions, action.name, index, "incometaxslab")}
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 1050,
                                }),
                              }} />

                            {errors?.[`incometaxslab[${index}].Gender_020`] && ( // Accessing errors for the specific line
                              <div className="error">
                                {errors?.[`incometaxslab[${index}].Gender_020`]}{" "}
                              </div>
                            )}
                          </td>
                          <td>
                            <input type="number" name="FromAmount" placeholder="00.00" className="form-control text-end" value={ele?.FromAmount} onChange={(e) => handleLineChange(e, index, "incometaxslab")} />
                          </td>
                          <td>
                            <input type="number" name="ToAmount" placeholder="00.00" className="form-control text-end" value={ele?.ToAmount} onChange={(e) => handleLineChange(e, index, "incometaxslab")} />
                          </td>
                          <td>
                            <input type="number" name="TaxPercent" placeholder="00.00" value={ele?.TaxPercent} className="form-control text-end" onChange={(e) => handleLineChange(e, index, "incometaxslab")} />
                          </td>
                          <td className="text-center">
                            <i className="bi bi-trash icons " onClick={() => handleLineDelete(ele, index)} />
                          </td>
                        </tr>))}
                    </tbody>


                  </Table>

                </div>
              </div>
              <div
                className="tab-pane fade show"
                id="taxExmpLimit"
                role="tabpanel"
                aria-labelledby="taxExmpLimit-tab"
              >
                <div className="table-responsive poc-head rounded">
                  <Table
                    style={{ background: "#ECECEC !important" }}
                    // id="poctable_head"
                    className="table table-bordered"
                  >
                    <thead id="thcolor" className="text-center align-middle  ">
                      <tr>
                        <th>
                          Tax Section
                        </th>
                        <th>
                          Deduction Type
                        </th>
                        <th>
                          Maximum Amount
                        </th>
                        <th>
                          Tax Percent
                        </th>

                      </tr>
                    </thead>

                    <tbody>
                      {formData.incometaxexception.map((ele, index) => (
                        <tr>
                          <td>
                            {ele?.ITSection}
                          </td>
                          <td>
                            <Select name="ITDeductionType_165" onChange={(selectedOptions, action) => handleLineSelectChange(selectedOptions, action.name, index, "incometaxexception")} value={deductionTypeOpt?.find(o => o.value == ele?.ITDeductionType_165)} placeholder="00.00" />
                          </td>
                          <td>
                            <input type="number" name="MaxAmount" value={ele?.MaxAmount} onChange={(e) => handleLineChange(e, index, "incometaxexception")} placeholder="00.00" className="form-control text-end" />
                          </td>
                          <td>
                            <input type="number" name="TaxPercent" value={ele?.TaxPercent} onChange={(e) => handleLineChange(e, index, "incometaxexception")} placeholder="00.00" className="form-control text-end" />
                          </td>

                        </tr>))}
                    </tbody>


                  </Table>

                </div>
              </div>

            </div>
          </div>

          <div className="row mt-3">
            <div className="text-end ">
              <button
                className="cancel-btn me-2"
                onClick={() => navigate('/rujul/hrm/income-tax-slab')}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={submitted ? true : false}
                className="custom-btn"
              >
                {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>

  );
};

export default IncomeTaxSlabAdd;
